import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { Cart } from 'featureSliced/widgets/Cart'
import { TimeLocation } from 'featureSliced/widgets/TimeLocationNew'
import { Footer } from './Footer'
import { FC, MouseEvent, useState } from 'react'
import { PaymentSteps } from './types'
import { CartContainer, OverwiewContainer, SpinnerContainer } from './styled'
import { RenderIf } from 'components/RenderIf'
import { Spinner } from 'featureSliced/entities/Spinner'
import { FakeCart } from 'featureSliced/widgets/Cart/FakeCart'
import { ICartProduct } from 'featureSliced/shared/store/generalTypes'
import { IPosition } from '../Bucket/types'
import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { ContextMenu } from 'components/ContextMenu'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'
import { useUpdateBucketProduct } from 'featureSliced/shared/hooks/openModals/useOpenProductModal/useUpdateBucketProduct'
import basket from 'assets/basket_small.svg'
import trashCan from 'assets/trashCan.svg'

type OverwiewProps = {
  moveToSuggestions: () => void
}

export const Overwiew: FC<OverwiewProps> = ({ moveToSuggestions }) => {
  // Hooks
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const openBucketProductModal = useUpdateBucketProduct()
  const cartProducts = useMySelector((state) => state.bucket.products)
  const productsList = useMySelector((state) =>
    state.categories.items.flatMap((cat) => cat.products)
  )
  const removeProductFromBucket = QRMBucketSlice.actions.removeProductFromBucket
  const isProductsLoaded = useMySelector((state) => state.categories.isLoaded)

  // State
  const [selectedProduct, setSelectedProduct] = useState<IBucketProduct>()
  const [position, setPosition] = useState<IPosition | null>(null)

  // Functions
  const openProductModal = (product: IBucketProduct) => {
    const fullProduct = productsList?.find((p) => p.id === product.productId)
    fullProduct && openBucketProductModal(product)
  }

  const handleProductClick = (
    _productId: number,
    e: MouseEvent<HTMLElement>,
    product2: ICartProduct
  ) => {
    const product = cartProducts?.find(
      (cP) => cP.uniqueId === product2.uniqueId
    )
    setSelectedProduct(product)
    setPosition({
      x: e.pageX + 145 > window.innerWidth ? e.pageX - 125 : e.pageX,
      y: e.pageY,
    })
  }

  return (
    <OverwiewContainer>
      <RenderIf condition={!isProductsLoaded}>
        <SpinnerContainer>
          <Spinner type="transparent" />
        </SpinnerContainer>
      </RenderIf>
      <TimeLocation />
      <RenderIf condition={!isProductsLoaded || !cartProducts?.length}>
        <CartContainer>
          <FakeCart />
        </CartContainer>
      </RenderIf>
      <RenderIf condition={isProductsLoaded && !!cartProducts?.length}>
        <CartContainer>
          <Cart
            products={cartProducts}
            handleProductClick={handleProductClick}
          />
          {/* TODO: create context menu here. Check BucketProducts as reference */}
        </CartContainer>
      </RenderIf>

      <RenderIf condition={!!position}>
        <ContextMenu
          position={position as IPosition}
          discardPosition={() => setPosition(null)}
          items={contextMenuItems(
            t,
            selectedProduct as IBucketProduct,
            openProductModal,
            (uniqueId: string) => dispatch(removeProductFromBucket(uniqueId))
            // !selectedProduct?.menuItems
          )}
        />
      </RenderIf>

      <Footer
        step={PaymentSteps.OVEWVIEW}
        onConfirmClick={moveToSuggestions}
        isButtonDisabled={!isProductsLoaded}
      />
    </OverwiewContainer>
  )
}

// TODO: isn't DRY. Repeats in BucketProducts.tsx
const contextMenuItems = (
  t: any,
  selectedProduct: IBucketProduct,
  handleEditClick: (product: IBucketProduct) => void,
  handleRemoveProduct: (id: string) => void
) => [
  {
    component: (
      <>
        <img src={basket} alt="Edit" />
        {t('buttons.edit')}
      </>
    ),
    onClick: () => handleEditClick(selectedProduct),
  },
  {
    component: (
      <>
        <img src={trashCan} alt="Remove" />
        {t('buttons.remove')}
      </>
    ),
    onClick: () => {
      handleRemoveProduct(selectedProduct.uniqueId as string)
    },
  },
]
